<template>
  <div :class="`${prefixDatePickClass}__body clearfix`">
    <ul :class="`${prefixClass}__title`">
      <li>{{ t('t.datepicker.hour') }}</li>
      <li>{{ t('t.datepicker.minute') }}</li>
    </ul>
    <div :class="prefixClass">
      <div :class="`${prefixClass}__select`">
        <ul ref="hours">
          <li v-for="(item, key) in hours" :key="key" @click.stop="setTime($event, 'hours')">
            <a :class="getClass('hour',key)" :index="item.value">{{ item.label }}</a>
          </li>
          <li v-for="index in 6" :key="'hour' + index" class="blank" @click.stop></li>
        </ul>
      </div>
      <div :class="`${prefixClass}__select`">
        <ul ref="minutes">
          <li v-for="(item, key) in minutes" :key="key" :index="item.value" @click.stop="setTime($event, 'minutes')">
            <a :class="getClass('minute',key)" :index="item.value">{{ item.label }}</a>
          </li>
          <li v-for="index in 6" :key="'minute' + index" class="blank" @click.stop></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import locale from '@/mixins/locale'

import {
  PREFIX_DATE_PICK_CLASS,
  PREFIX_TIME_SCROLL_CLASS,
  CLASS_DISABLED
} from '../constants'
export default {
  name: 'TTimeScroll',
  mixins: [locale],
  props: {
    hour: {
      type: Number,
      default: 0
    },
    minute: {
      type: Number,
      default: 0
    },
    picked: {
      type: String,
      default: ''
    },
    minSelectRange: {
      type: Object,
      default: () => {}
    },
    maxSelectRange: {
      type: Object,
      default: () => {}
    },
    format: {
      type: String,
      default: 'HH:mm'
    },
    hours: {
      type: Array,
      default: () => []
    },
    minutes: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      prefixDatePickClass: PREFIX_DATE_PICK_CLASS,
      prefixClass: PREFIX_TIME_SCROLL_CLASS,
      hourValue: '',
      minuteValue: '',
      formatter: moment()
    }
  },
  watch: {
    hour(val) {
      this.hourValue = val
      const _height = 32
      let hourTop = val * _height
      hourTop = hourTop < 0 ? 0 : hourTop
      this.$refs.hours.scrollTop = hourTop
    },
    minute(val) {
      this.minuteValue = val
      const _height = 32
      let minuteTop = val * _height
      minuteTop = minuteTop < 0 ? 0 : minuteTop
      this.$refs.minutes.scrollTop = minuteTop
    }
  },
  mounted() {
    this.hourValue = this.hour
    this.minuteValue = this.minute
  },
  methods: {
    getClass(key, val) {
      let _classes = []
      if (this[key] !== undefined && this[key] === val) {
        _classes.push(`${PREFIX_TIME_SCROLL_CLASS}--selected`)
      }
      if (this.picked) {
        let _pickDate = moment(this.picked, 'YYYY/MM/DD')
        if (this.minSelectRange && _pickDate.isSame(this.minSelectRange, 'date')) {
          let _hour = this.hour || this.minSelectRange.hour()
          let _minute = this.minute || this.minSelectRange.minute()
          let _second = this.second || this.minSelectRange.second()
          let _pickerTime = moment(`${this.picked} ${key === 'hour' ? val : _hour}:${key === 'minute' ? val : _minute}:${key === 'second' ? val : _second}`, 'YYYY/MM/DD HH:mm:ss')
          if (_pickerTime.isBefore(this.minSelectRange, key)) {
            _classes.push(CLASS_DISABLED)
          }
        }
        if (this.maxSelectRange && _pickDate.isSame(this.maxSelectRange, 'date')) {
          let _hour = this.hour || this.maxSelectRange.hour()
          let _minute = this.minute || this.maxSelectRange.minute()
          let _second = this.second || this.maxSelectRange.second()
          let _pickerTime = moment(`${this.picked} ${key === 'hour' ? val : _hour}:${key === 'minute' ? val : _minute}:${key === 'second' ? val : _second}`, 'YYYY/MM/DD HH:mm:ss')
          if (_pickerTime.isAfter(this.maxSelectRange, key)) {
            _classes.push(CLASS_DISABLED)
          }
        }
      }
      return _classes
    },
    updateTime(type, timeIndex) {
      if (type === 'hours') {
        this.hourValue = timeIndex
      } else if (type === 'minutes') {
        this.minuteValue = timeIndex
      }
    },
    setTime(event, type) {
      if (event.target.className.indexOf(CLASS_DISABLED) > -1) {
        return
      }
      let index = event.target.getAttribute('index')
      // const _height = 40
      // const top = event.target.offsetTop
      // // const scrollTop = top > _height ? top - _height : top
      // console.log('before', this.$refs[type].scrollTop)
      // this.$refs[type].scrollTop = 0
      // console.log('top', index * _height)
      // console.log('after', this.$refs[type].scrollTop)
      this.updateTime(type, parseInt(index))
      this.$emit('pick', type.substr(0, type.length - 1), parseInt(index))
    },
    $_setScrollTop () {
      this.$nextTick(() => {
        const _height = 32
        let hourTop = this.hourValue * _height
        this.$refs.hours.scrollTop = hourTop
        let minuteTop = this.minuteValue * _height
        this.$refs.minutes.scrollTop = minuteTop
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/date-picker/basic/time-scroll.vue